import React from 'react';

import {Grid} from 'semantic-ui-react'

import Menu from './Menu'

interface Props{
    name:string,
    date:string
}

const Header = (props:Props) => {
    return(
    <Grid style={{padding:'4em'}} centered columns={3} container stackable>
            <Grid.Column>
            </Grid.Column>
            <Grid.Column textAlign='center'>
                <h1>{props.name}</h1>
                <h4>{props.date}</h4>
            </Grid.Column>
            
            <Grid.Column verticalAlign='middle'>
                <Menu />
            </Grid.Column>
    </Grid>

    )
}

export default Header;